import { createReducer, on } from "@ngrx/store";
import { addTipoResponsableIvas, addTipoResponsableIvasError, clearTipoResponsablsIvas, deleteTipoResponsableIva, updateTipoResponsableIva } from "../actions/tipoResponsableIva.actions";
import { initialTipoResponsableIvasState } from "../../core/interfaces/models/tipoResponsableIva.interface";

export const ivaReducer = createReducer(
  initialTipoResponsableIvasState,
  on(addTipoResponsableIvas, (_, { tipoResponsableIvasState }) => (
    tipoResponsableIvasState
  )),
  on(addTipoResponsableIvasError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateTipoResponsableIva, (state, { tipoResponsableIva }) => ({
    ...state,
    actividades: state.tipoResponsableIvas.map(u =>
      u.id === tipoResponsableIva.id ? tipoResponsableIva : u
    )
  })),
  on(deleteTipoResponsableIva, (state, { id }) => ({
    ...state,
    tipoResponsableIvas: state.tipoResponsableIvas.filter(u => u.id !== id)
  })),

  on(clearTipoResponsablsIvas, () => initialTipoResponsableIvasState)
);
  

